import { useEffect, useState } from "react"

/** Giá trị trễ `ms` sau lần đổi cuối — ô tìm gõ liên tục không gọi API mỗi phím. */
export function useDebounced<T>(value: T, ms: number): T {
  const [v, setV] = useState(value)
  useEffect(() => {
    const t = setTimeout(() => setV(value), ms)
    return () => clearTimeout(t)
  }, [value, ms])
  return v
}
